export const useProductPricing = (product, hasMemberPrice, loggedIn) => {
  let updatedProduct = { ...product };
  if (!loggedIn && hasMemberPrice) {
    updatedProduct = {
      ...updatedProduct,
      price: product?.memberPrice,
      previousPrice: product?.price,
    };
    return updatedProduct;
  }
  return product;
};